import { styled } from 'linaria/react';

export const Title = styled.h2`
	margin: 0;
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 32px;
	color: var(--text-primary);
	
	@media (max-width: 560px) {
		font-size: 20px;
		line-height: 28px;
	}
`;
export const Subtitle = styled.h3`
	margin: 0 0 4px;
	font-style: normal;
	font-weight: 600;
	font-size: 20px;
	line-height: 28px;
	color: var(--text-primary);
	
	@media (max-width: 560px) {
		font-weight: normal;
		font-size: 18px;
		line-height: 24px;
	}
`;
export const Text = styled.div`
	margin: 0;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;
	color: var(--text-secondary);
`;
